import React from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import UserEdit from './views/Users/Edit';
import UserList from './views/Users/List';
import GroupsList from './views/Groups/List';
import GroupsEdit from './views/Groups/Edit';
import { routes } from '../common/constants';

const Authorization = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/users`} exact component={UserList} />
      <Route path={`${path}/users/:userId`} component={UserEdit} />
      <Route path={`${path}/groups`} exact component={GroupsList} />
      <Route path={`${path}/groups/:groupId`} component={GroupsEdit} />
      <Route
        path={`${routes.AUTH}`}
        exact
        render={() => <Redirect to={`/${routes.AUTH_USERS}`} />}
      />
      <Route render={() => <h1>404 - Not found</h1>} />
    </Switch>
  );
};

export default Authorization;
